import React, { StrictMode, useContext, Suspense } from 'react';

import { Router, Redirect } from '@reach/router';

import { AuthContext } from './AuthContext';

import { Login } from './pages/Login';
import { Logout } from './pages/Logout';
import { Registration } from './pages/Registration';
import { Page404 } from './pages/Page404';

// import { NavBar } from './components/NavBar';
// import { Footer } from './components/Footer';
import { Spinner } from './components/Spinner';

import AuthenticatedTemplate from './components/Template';

const Home = React.lazy(() => import('./pages/Home'));
const UserAdministration = React.lazy(() => import('./pages/UserAdministration'));
// const ReportsManagement = React.lazy(() => import('./pages/ReportsManagement'));
const PrintingOrder = React.lazy(() => import('./pages/PrintingOrder'));
const PrintingOrderView = React.lazy(() => import('./components/PrintingOrder/view'));
const JobOrder = React.lazy(() => import('./pages/JobOrder'));
const JobOrderView = React.lazy(() => import('./components/JobOrder/view'));
// const ReportViewers = React.lazy(() => import('./components/ReportsManagement/viewers'));
// const ReportView = React.lazy(() => import('./components/Dashboard/reportView'));
const AuditTrail = React.lazy(() => import('./pages/AuditTrail'));
const Settings = React.lazy(() => import('./components/Settings'));

export const App = () => {
	const { isAuth } = useContext(AuthContext);
	const { userData } = useContext(AuthContext);

	return (
		<StrictMode>
			<Suspense fallback={<Spinner />}>
				{/* <NavBar /> */}
					<Router>
						<Page404 default />
						{
							isAuth && 
							<AuthenticatedTemplate default>
								<Home path='/' />
								<UserAdministration path='/user-administration' />
								<PrintingOrder path='/printing-order' />
								<PrintingOrderView path='/printing-order/:po_uid' />
								<JobOrder path='/job-order' />
								<JobOrderView path='/job-order/:jo_uid' />
								{/* <ReportsManagement path='/reports-management' />
								<ReportViewers path='/reports-management/viewers/:report_uid' />
								<ReportView path='/view/:report_uid' /> */}
								<AuditTrail path='/audit-trail' />
								<Settings path='/settings' />
							</AuthenticatedTemplate>
						}
						
						{
							// If is not authenticated...
						}
						{ !isAuth && <Login path='/' /> }
						{ !isAuth && <Registration path='/register' /> }
						{ !isAuth && <Redirect from='/user-administration' to='/' noThrow /> }
						{ !isAuth && <Redirect from='/reports-management' to='/' noThrow /> }
						{ !isAuth && <Redirect from='/logout' to='/' noThrow /> }

						{
							// If it's authenticated user...
						}
						{/* { isAuth && <Redirect from='/login' to='/' noThrow /> }
						{ isAuth && <Redirect from='/register' to='/' noThrow /> } */}

						{
							// If it's authenticated user but don't have administrator role...
						}
						{ 
							(isAuth && !userData.isSuperAdmin) && 
							<Redirect from='/user-administration' to='/' noThrow />
						}
						{ 
							(isAuth && !userData.isSuperAdmin) && 
							<Redirect from='/reports-management' to='/' noThrow />
						}

						<Logout path='/logout' />
					</Router>
				{/* <Footer /> */}
			</Suspense>
		</StrictMode>
	);
};
